import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Pencil } from "lucide-react";
import { UidContext } from "../App.Context";
import EditProfilModal from "./EditProfilModal";

/**
 * Bouton + modale d'édition d'un profil.
 * - Sur la page profil (`/userprofil/:id`), l'utilisateur cible est lu dans l'URL.
 * - Ailleurs (ex. tableau d'administration), on passe `userId` explicitement.
 * `variant="inline"` rend un bouton compact (ds-btn) au lieu du bouton flottant.
 */
const UpdateProfil = ({ userId, variant = "floating" }) => {
  const [open, setOpen] = useState(false);
  const { id: paramId } = useParams();
  const uid = useContext(UidContext);
  const usersData = useSelector((state) => state.usersReducer);
  const loggedUser = useSelector((state) => state.userReducer);

  const targetId = `${userId ?? paramId ?? ""}`;
  const user = Object.values(usersData).find((u) => `${u.id}` === targetId);
  if (!user) return null;

  const isInline = variant === "inline";

  return (
    <>
      {isInline ? (
        <button className="ds-btn ds-btn--ghost" onClick={() => setOpen(true)}>
          <Pencil size={14} />
          Éditer
        </button>
      ) : (
        <div className="action_edit">
          <button className="editButton" onClick={() => setOpen(true)}>
            <Pencil size={14} />
            Éditer le profil
          </button>
        </div>
      )}
      {open && (
        <EditProfilModal
          user={user}
          isSelf={uid + "" === targetId}
          canManage={loggedUser.isAdmin === true}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default UpdateProfil;
